export function dispatchCustomEvent<T = any>(eventName: string, detail?: T) {
  const event = new CustomEvent(eventName, { detail });
  window.dispatchEvent(event);
}
